export default __webpack_public_path__ + "static/media/eurovision-black.56a34af8.svg";